import toggleModal from '@/scripts/utils/toggle-modal';
import isMobile from '@/scripts/utils/detect-mobile';
import Hammer from 'hammerjs';
import initCustomDatepicker from '@/scripts/lib/datepicker';
import initCustomSelect from '@/scripts/lib/select';
import { DOCUMENT_ELEMENT, KEY_CODES } from '@/scripts/constants';
import clickOutside from 'click-outside';
import contains from 'node-contains';
import './BookingMenu.scss';

const defaults = {
  element: null,
  datepicker: '[data-role*="datepicker"]',
  select: '[data-role*="select"]',
  triggerButton: '[data-role*="booking-menu-trigger"]',
  scrollContainer: '[data-role*="booking-menu-scrolling-container"]',
  activeClass: 'booking-menu-opened',
};

export default class BookingMenu {
  constructor(props) {
    const options = Object.assign({}, defaults, props);

    this.element = options.element;
    if (!this.element) return;

    this.datepickers = Array
      .from(this.element.querySelectorAll(options.datepicker))
      .map(el => initCustomDatepicker(el));

    this.selects = Array // eslint-disable-line no-unused-vars
      .from(this.element.querySelectorAll('[data-role*="select"]'))
      .map(el => initCustomSelect(el));

    this.triggerButtons = document.querySelectorAll(options.triggerButton);

    this.activeClass = options.activeClass;
    this.scrollContainer = options.activeClass;

    this.init();
  }

  get activeStatus() {
    return DOCUMENT_ELEMENT.classList.contains(this.activeClass);
  }

  toggleStatus(active) {
    DOCUMENT_ELEMENT.classList.toggle(this.activeClass, active);

    return toggleModal(
      active,
      this.scrollContainer,
      this.element,
    );
  }

  initKeyboard() {
    document.addEventListener('keyup', (e) => {
      if (e.keyCode === KEY_CODES.ESC && this.activeStatus) this.toggleStatus(false);
    });
  }

  initMobileEvents() {
    const hammer = new Hammer(this.element);

    hammer.on('swiperight', () => {
      if (this.activeStatus) this.toggleStatus(false);
    });
  }

  init() {
    this.triggerButtons
      .forEach(button => button.addEventListener('click', (e) => {
        e.preventDefault();
        return this.toggleStatus(!this.activeStatus);
      }));

    clickOutside(this.element, (e) => {
      if (Array.from(this.triggerButtons).find(el => contains(el, e.target))) return;
      if (this.activeStatus) this.toggleStatus(false);
    });

    this.initKeyboard();
    if (isMobile()) {
      this.initMobileEvents();
    }
  }
}



// WEBPACK FOOTER //
// ./scripts/blocks/bookingMenu/BookingMenu.js